import { Title } from '@shared/components/title/models';
import { Project } from '@shared/models';
import { ElasticSearchResponse, ShowcaseDocument } from '@shared/services/elastic-search/models';

const splitStoreName = (s: string): [string, string] => {
  const split = s.split(' ');
  const storeName = split.slice(1).join(' ');
  return [split[0]!, storeName];
};
const makeTitle = (s: string): Title => {
  const split = splitStoreName(s);
  return { text: `${split[0]}\\\\[[${split[1]}]]`, as: 'span' };
};

export const showcaseSerializer = (showcases: ElasticSearchResponse<ShowcaseDocument>): Project[] =>
  showcases.hits.hits.map((showcase) => {
    const source = showcase._source;
    return {
      images: source?.visuels_x5 ?? [],
      name: source?.title?.[0] ?? '',
      createdBy: makeTitle(source?.store_name?.[0] ?? ''),
      kitchenerNote: source?.le_mot_du_kitchener?.[0] ?? '',
    };
  });
